export const __URL = 'https://api-chamados.josoftware.com.br/api';
// export const __URL = 'HTTP://192.168.0.103/api-chamados/public_html/api'; 
export const __PRIORIDADES = [
    {
        'value': 1,
        'label': 'Baixíssima'
    } ,  {
        'value': 2,
        'label': 'Baixa'
    },  {
        'value': 3,
        'label': 'Média'
    },  {
        'value': 4,
        'label': 'Alta'
    },  {
        'value': 5,
        'label': 'Urgente'
    }
];

// Situação interna do chamado (só equipe interna enxerga/edita). Vazio = sem situação.
export const __SITUACOES = [
    {
        'value': 'B',
        'label': 'Banco de Dados'
    }, {
        'value': 'N',
        'label': 'Novo Projeto'
    }, {
        'value': 'E',
        'label': 'Erro Front'
    }, {
        'value': 'F',
        'label': 'Novo Filtro Relatório'
    }
];
export default {__URL, __PRIORIDADES, __SITUACOES};